import { Grid, IconButton, Tooltip, Typography } from '@mui/material';
import React from 'react';
import MuiIcon from '../../../../shared/styles/mui/helpers/mui-icon.helper';

interface IProps {
  onReload: () => void;
  handleCreateReportClick: () => void;
}

function TaskImportToolbarComponent({ onReload, handleCreateReportClick }: IProps) {

  return (<Grid paddingX={2} container direction='row' alignItems='center' justifyContent='flex-start'>

    {/* Reload */}
    <Tooltip title='Reload'>
      <IconButton color='secondary' onClick={onReload}>{MuiIcon.RELOAD()}</IconButton>
    </Tooltip>

    {/* Title */}
    <Typography sx={{ flexGrow: 1 }} variant='subtitle2'>Task Import List</Typography>

    {/* Create Report */}
    <Tooltip title='Create Report'>
      <IconButton color='primary' onClick={handleCreateReportClick}>{MuiIcon.ADD_CIRCLE()}</IconButton>
    </Tooltip>

  </Grid>);
}
export default TaskImportToolbarComponent;